import * as React from "react";

function SvgDownload(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={16.917} height={17} {...props}>
        <path
          data-name="Combined Shape"
          d="M7.646.741v9.234L5.9 8.226a.745.745 0 00-.525-.216.727.727 0 00-.522.218.739.739 0 000 1.047l3.011 3.009a.739.739 0 001.047 0l3.01-3.009a.739.739 0 000-1.047.739.739 0 00-.524-.216.735.735 0 00-.524.216L9.126 9.974V.74a.74.74 0 00-.74-.741.74.74 0 00-.74.742zM0 11.619v4.209a1.174 1.174 0 001.172 1.175h14.572a1.174 1.174 0 001.172-1.172v-4.212a.652.652 0 00-.653-.651.653.653 0 00-.653.653v3.689a.389.389 0 01-.389.389H1.694a.39.39 0 01-.394-.389v-3.691a.653.653 0 00-.653-.653.653.653 0 00-.647.653z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgDownload;
